var _rect, _path, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIconActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    fill: "#0095FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 30H18.9998M26.9998 17C26.9998 15.4087 26.3676 13.8826 25.2424 12.7574C24.1172 11.6321 22.5911 11 20.9998 11C19.4085 11 17.8824 11.6321 16.7571 12.7574C15.6319 13.8826 14.9998 15.4087 14.9998 17C14.9998 20.0902 14.2202 22.206 13.3494 23.6054C12.6149 24.7859 12.2476 25.3761 12.2611 25.5408C12.276 25.7231 12.3146 25.7926 12.4616 25.9016C12.5942 26 13.1924 26 14.3886 26H27.6109C28.8072 26 29.4053 26 29.538 25.9016C29.6849 25.7926 29.7235 25.7231 29.7384 25.5408C29.7519 25.3761 29.3846 24.7859 28.6501 23.6054C27.7793 22.206 26.9998 20.0902 26.9998 17Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 8,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#E73751"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 8,
    width: 8,
    height: 8,
    rx: 4,
    stroke: "#0095FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIconActive);
export default __webpack_public_path__ + "static/media/bellIconActive.f8f520585621245fc6fc9b2e392f61e4.svg";
export { ForwardRef as ReactComponent };